import { createApiSlice } from "@common/common-slice/commonSlice";

import { CRUD_COURSE_LEVEL } from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addCourseLevel",
    method: "post",
    url: CRUD_COURSE_LEVEL,
    stateKey: "message",
  },
  {
    name: "updateCourseLevel",
    method: "put",
    url: CRUD_COURSE_LEVEL,
    stateKey: "message",
  },
  {
    name: "deleteCourseLevel",
    method: "delete",
    url: CRUD_COURSE_LEVEL,
    stateKey: "message",
  },
  {
    name: "getCourseLevel",
    method: "get",
    url: CRUD_COURSE_LEVEL,
    stateKey: "data",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
  },
  reducers: {
  },
  // extraReducers: {
  //   // Example of custom extra reducer
  //   someCustomAction: (state, action) => {
  //     // Custom reducer logic
  //   },
  // },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "courseLevel",
  apiConfig,
  customReducers
);
const courseLevelSlice = slice;
// Export the slice's reducer
export default courseLevelSlice.reducer;

// Dynamically export all actions
export const actionsExports = actions;

// Destructure and export thunks directly from thunksExports
export const {
  addCourseLevel,
  updateCourseLevel,
  deleteCourseLevel,
  getCourseLevel,
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actionsExports;
